<script>
	import options from './OrderOverview.options'
	export default options
</script>

<template>
	<article class="nlx-order-overview">
		
		<template v-if="isReceiptOrConfirm">
			<BasketComponent :location="proceedType" />
		</template>

		<section class="nlx-order-overview__cart-summary">

			<template v-for="(field,fieldIndex) in fieldList" :key="fieldIndex">
				<div class="nlx-order-overview__cart-summary-item" :class="{'nlx-order-overview__cart-summary-item--total':(field === 'orderTotal')}">
					<p>{{getLabel('basket' + (field.charAt(0).toUpperCase() + field.slice(1)))}}</p>
					<p v-if="hasDataLoaded">{{cartOverviewData[field]}}</p>
				</div>
			</template>

			<p class="nlx-order-overview__vat-label">{{getLabel('basketPriceTotalVat')}}</p>
		</section>

		<section class="nlx-order-overview__info-labels">
			<p>{{getLabel('basketFreeShipping')}}</p>
			<p>{{getLabel('basketDiscountCalculatedWhen')}}</p>
		</section>

		<div class="nlx-order-overview__proceed-button-container">
			<button :disabled="buttonDisabled" @click="goToCheckout" class="nlx-button nlx-button--confirm">{{getLabel(proceedLabel)}}</button>
		</div>

		<div v-if="isUserImpersonated && hasDataLoaded" class="nlx-basket-item-spot__customer-service-reason">
			<label for="costumer-service-reason-select">{{getLabel('basketOrderTypesDropdownTitle')}}</label>
			<select v-model="selectedOrderType" @change="selectOrderType()" name="costumer-service-reason" id="costumer-service-reason-select">
				<option disabled value="">{{getLabel('basketOrderTypesDefaultOption')}}</option>
				<option v-for="(reason, index) in orderTypes" :key="index" :value="reason">{{reason.displayValue}}</option>
			</select>
		</div>

	</article>
</template>
